/**
 * @file Renders the heading for the reset-password confirmation screen.
 */
import FormHeader from "./FormHeader";

/**
 * Renders the heading and instructions for entering the reset code and
 * new password.
 */
const ResetPasswordConfirmHeader = (): JSX.Element => {
  return (
    <FormHeader
      heading="Set new password"
      text="If your email is registered, you should receive a verification code. Please enter it below to set your new password."
    />
  );
};

export default ResetPasswordConfirmHeader;
